export default "__VITE_ASSET__v1VsRqbD__"